module.exports = __webpack_public_path__ + "static/media/remy.9adcb8aa.png";